import React from 'react';
import { styled, keyframes } from '@mui/material/styles';

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4); }
  70% { box-shadow: 0 0 0 4px rgba(76, 175, 80, 0); }
  100% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
`;

const Dot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isOnline' && prop !== 'size',
})<{ isOnline: boolean; size?: number }>(({ isOnline, size = 10 }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: isOnline ? '#4caf50' : '#9e9e9e',
  border: '2px solid #1e1e2e',
  animation: isOnline ? `${pulse} 2s ease-in-out infinite` : 'none',
  flexShrink: 0,
}));

interface PresenceIndicatorProps {
  isOnline: boolean;
  size?: number;
}

const PresenceIndicator: React.FC<PresenceIndicatorProps> = ({ isOnline, size }) => {
  return <Dot isOnline={isOnline} size={size} />;
};

export default PresenceIndicator;
